<template>
  <div class="appointment content" v-if="appointment">
    <Row type="flex">
      <Col :span="24">
        <AppointmentItemInfo
          :appointment="appointment"
          @refresh-appointment="getAppointment"
        />
      </Col>
      <!-- <Col :span="8">
        <chat :chat="appointment.chat" v-if="!loading" />
      </Col> -->
    </Row>
  </div>
</template>

<script>
import AppointmentService from "@/services/AppointmentService";
import AppointmentItemInfo from "@/components/AppointmentItemInfo";
// import Chat from "@/components/Chat";
import loadingMixin from "../mixins/loadingMixin";


export default {
  name: "AppointmentItem",


  components: {
    AppointmentItemInfo,
    // Chat,
  },


  mixins: [
    loadingMixin,
  ],


  data() {
    return {
      service: new AppointmentService(),
      appointment: ""
    };
  },


  computed: {
    appointmentNumber() {
      return this.$route.params.id;
    },
  },


  async created() {
    this.loading = true;

    await this.getAppointment();

    // TODO: enable?
    // await this.appointment.chat.getChat();
    this.loading = false;
  },


  methods: {
    async getAppointment() {
      this.appointment = await this.service.getAppointmentById(
        this.appointmentNumber
      );
    },
  },
};
</script>
